import React from "react";
import UsersPerformanceTable from "../../components/Users/UsersPerformanceTable/UsersPerformanceTable";

const OperatorsOverviewPage: React.FC<{}> = (props) => {
  return <UsersPerformanceTable />;
};

export default OperatorsOverviewPage;
